<template>
  <div v-if="hideBlock" class="mainwrap">
    <header class="header">
      <div class="new-header__top">
        <div class="wrapper">
          <div class="new-header__top_wrapper">
            <img
              alt="image"
              src="@/assets/img/svg/main-logo.svg"
              style="cursor:pointer;"
              class="new-logo newheader__logo"
              @click="$router.push({ name: 'Main' })"
            />
            <div class="new-schedule">
              <div class="new-schedule__right">
                <span class="new-schedule__title">
                  <span class="new-schedule__text_grey">
                    Время работы:
                  </span>
                </span>
                <span class="new-schedule__title">
                  <!--                 {{ info.workingTime.from }} – {{ info.workingTime.to }} МСК -->
                  <!-- TODO: change format of time in DB -->
                  10:00 – 22:00 МСК
                </span>
              </div>
            </div>
            <div class="navs-wrapper-head">
              <router-link
                class="nav link"
                to="/rules"
                :class="{ 'curr-page': $route.name === 'Rules' }"
                >ПРАВИЛА ОБМЕНА</router-link
              >
              <router-link
                class="nav link"
                to="/partners"
                :class="{ 'curr-page': $route.name === 'Partners' }"
                >ПАРТНЕРСКАЯ ПРОГРАММА</router-link
              >
              <router-link
                class="nav link"
                to="/reviews"
                :class="{ 'curr-page': $route.name === 'Reviews' }"
                >ОТЗЫВЫ</router-link
              >
            </div>
            <div class="new-header__actions" v-if="token && screen > 615">
              <div ref="zornet" @click="dropdawn = !dropdawn" class="login">
                <span class="login__title">
                  {{ login }}
                </span>
                <div class="user-logo">
                  {{ login[0] }}
                </div>
                <span
                  class="div_zornet"
                  :class="{ 'div_zornet-active': dropdawn }"
                ></span>
                <div
                  ref="dropdawn"
                  class="dropdawn-wrapper"
                  :class="{ 'dropdawn-wrapper-active': dropdawn }"
                >
                  <div class="dropdawn">
                    <span class="dropdawn__item" @click="openCabinet('home')">
                      <img
                        alt="image"
                        src="@/assets/img/new/profile/user.svg"
                      />
                      Личные данные
                    </span>
                    <span
                      class="dropdawn__item"
                      @click="openCabinet('referal-link')"
                    >
                      <img
                        alt="image"
                        src="@/assets/img/new/profile/link.svg"
                      />
                      Реферальная ссылка
                    </span>
                    <span
                      class="dropdawn__item"
                      @click="openCabinet('balance')"
                    >
                      <img
                        alt="image"
                        src="@/assets/img/new/profile/wallet.svg"
                      />
                      Внутренний счет
                    </span>

                    <span class="dropdawn__item" @click="openCabinet('faq')">
                      <img alt="image" src="@/assets/img/new/profile/faq.svg" />
                      Партнерская программа FAQ
                    </span>
                    <span
                      class="dropdawn__item"
                      @click="
                        () => {
                          $router.push('/logout');
                          close();
                        }
                      "
                    >
                      <img alt="image" src="@/assets/img/svg/exit.svg" />
                      Выход
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="new-header__actions" v-else>
              <button
                @click.prevent="Login()"
                style="cursor:pointer;"
                class="new-header__login"
              >
                ВОЙТИ
              </button>
              <a @click.prevent="Register()" href="" class="reg__btn"
                >ЗАРЕГИСТРИРОВАТЬСЯ</a
              >
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="burger" @click="close ? close() : open()">
      <img alt="image" v-if="close" src="@/assets/img/svg/close-icon.svg" />
      <img alt="image" v-else src="@/assets/img/svg/menu-icon.svg" />
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
//
export default {
  name: "Header",
  data() {
    return {
      dropdawn: false
    };
  },
  props: {
    close: {
      type: Function,
      default: null
    }
  },
  computed: {
    ...mapState("auth", ["token", "login"]),
    ...mapState("cabinet", ["page"]),
    ...mapState("modals", ["sidebar"]),
    ...mapState("info", ["info"]),
    screen() {
      return window.screen.width;
    },
    hideBlock() {
      if (this.$route.name === "Cabinet" && this.screen < 1200) {
        return false;
      } else if (this.$route.name === "Cabinet" && this.screen > 1200) {
        return true;
      } else {
        return true;
      }
    }
  },
  created() {
    document.addEventListener("click", this.dropdawnClick);
  },
  destroyed() {
    document.removeEventListener("click", this.dropdawnClick);
  },

  methods: {
    ...mapActions("modals", ["openModal"]),
    ...mapActions("auth", ["userLogin", "userRegister"]),
    dropdawnClick(e) {
      let el = this.$refs.dropdawn;
      let zornet = this.$refs.zornet;
      let target = e.target;
      let isOpen = this;
      if (this.dropdawn) {
        if (
          el !== target &&
          !el.contains(target) &&
          zornet !== target &&
          !zornet.contains(target)
        ) {
          this.dropdawn = false;
        }
      }
    },

    openCabinet(name) {
      if (this.$route.name !== "Cabinet")
        this.$router.push({ name: "Cabinet" });
      this.$store.commit("cabinet/setPage", name);
      this.$dropdawn = false;
    },
    open() {
      this.$store.commit("modals/open", true);
    },
    Login() {
      this.openModal({
        name: "login",
        success: this.userLogin
      });
    },

    Register() {
      this.openModal({
        name: "register",
        success: this.userRegister
      });
    }
  }
};
</script>

<style scoped>
.new-header__top_wrapper {
  display: flex;
  align-items: center;
  height: 100%;
}
.icon-vk svg {
  display: inline-block;
  fill: #74dbef;
  height: 25px;
  width: 25px;
}
.wrapper {
  height: 100%;
}
.new-header__top {
  height: 100%;
}

.reg__btn {
  color: #1a1814;
  font-size: 15px;
  z-index: 1;
  font-weight: 700;
}

.navs-wrapper-head {
  display: flex;
  width: max-content;
}
.link {
  color: #1a1814;
  z-index: 1;

  font-weight: 700;
  font-size: 13px;
}
.link:hover {
  color: #f80000;
}
.curr-page {
  color: #f80000;
}
.mainwrap {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  align-items: center;
}
.login__title {
  color: var(--main-black);
  font-size: 17px;
  line-height: 21.67px;
  font-weight: 500;
}
/* .link.router-link-exact-active {
  color: var(--primary-v);
  position: relative;
  font-weight: 600;
}
.link.router-link-exact-active::before {
  position: absolute;
  content: "";
  height: 2px;
  width: 110%;
  left: -5%;
  background-color: var(--primary-v);
  bottom: 0px;
} */
</style>



// WEBPACK FOOTER //
// src/components/ui/Header.vue